const DIMENSIONS = {
  headerHeight: 88,
  contentWidth: 800,
  sidebarWidth: 256,
  sidebarWidthCollapsed: 64
};

export default DIMENSIONS;



// WEBPACK FOOTER //
// ./src/library/dimensions.js